(function () {
  'use strict';

  if (window.__wsmSearchRouterCanonicalV1) return;
  window.__wsmSearchRouterCanonicalV1 = true;

  var config = (window.WSMRuntimeConfig && window.WSMRuntimeConfig.search) || {};
  var finalPath = config.path || '/pages/course-search';
  var finalView = config.view || 'wsm-twostore-v3d-search-v2noflash';

  function isSearchForm(form) {
    if (!form || !form.querySelector) return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/pages/search') > -1 ||
      action.indexOf('/pages/course-search') > -1 ||
      form.hasAttribute('data-wsm-global-search') ||
      form.hasAttribute('data-wsm-search-form') ||
      form.hasAttribute('data-wsm-mobile-search-form') ||
      form.classList.contains('wsm-v3d-global-search') ||
      form.classList.contains('wsm-header-search-form') ||
      form.classList.contains('wsm-mobile-search-form');
  }

  function queryInput(form) {
    return form && form.querySelector(
      'input[name="q"], input[type="search"], input.wsm-header-search-input, input.wsm-mobile-search-input'
    );
  }

  function normalizeForm(form) {
    if (!isSearchForm(form)) return;
    form.setAttribute('action', finalPath);
    form.setAttribute('method', 'get');

    var hidden = form.querySelector('input[name="view"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'view';
      form.insertBefore(hidden, form.firstChild);
    }
    hidden.value = finalView;
  }

  function normalizeAll() {
    document.querySelectorAll('form').forEach(normalizeForm);
  }

  function destination(form) {
    var params = new URLSearchParams();
    var current = new URLSearchParams(window.location.search || '');
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      if (current.has(key)) params.set(key, current.get(key));
    });
    params.set('view', finalView);

    var input = queryInput(form);
    var query = input ? String(input.value || '').trim() : '';
    if (query) params.set('q', query);
    return finalPath + '?' + params.toString();
  }

  function isResultsForm(form) {
    return Boolean(form && form.closest && form.closest('[data-wsm-v3ds-search]'));
  }

  function route(form, event) {
    if (!isSearchForm(form) || isResultsForm(form)) return false;
    normalizeForm(form);
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    window.location.assign(destination(form));
    return true;
  }

  document.addEventListener('submit', function (event) {
    route(event.target, event);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.wsm-header-search-submit, .wsm-mobile-search-submit')
      : null;
    if (!button || button.type === 'submit') return;
    route(button.closest('form'), event);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeAll, { once: true });
  } else {
    normalizeAll();
  }
  window.setTimeout(normalizeAll, 300);
})();
